import React, { useState, useEffect } from "react";
import axiosInstance from '../../../axiosInstance';
import { fetchSubFormsDropdownValues } from "../services/api";
import { useNavigate } from "react-router-dom";
// import { Container, Col, Row, Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Table from 'apollo-react/components/Table';
import Typography from 'apollo-react/components/Typography';
import AutocompleteInput from "../../common/Form/autocompleteInput";
import TableActions from "../../common/DataTable/TableActions";
import Modal from 'apollo-react/components/Modal';
import Checkbox from 'apollo-react/components/Checkbox';
import CheckboxGroup from 'apollo-react/components/CheckboxGroup';

import { Formik, Form, Field } from "formik";
import Grid from "apollo-react/components/Grid";
import SwitchInput from "../../common/Form/switchInput";
import TextInput from "../../common/Form/textInput";
import Button from "../../common/Button";

export default function UpdateForm({persona}) {
  const { id } = useParams();
  const [dropdowns, setDropdowns] = useState([{ id: 0, textValue: "" }]);
  const [options, setOptions] = useState([]);
  const [subforms, setSubforms] = useState([]);
  const [forms, setForms] = useState({
    name: "",
    description: "",
    published: false,
    subforms: [],
    disableEdit: false,
    has_product_details: false,
    has_manufacturers_site: false,
  });
  const [formsCopy, setFormsCopy] = useState({
    forms: {
      name: "",
      description: "",
      published: false,
      subforms: [],
      disableEdit: false,
      has_product_details: false,
      has_manufacturers_site: false,
    },
    subformsRows: [],
    formPublished: false,
    includeSubforms: [],
  });
  const [resp, setResp] = useState("");
  const [formPublished, setFormPublished] = useState(false);
  const [subformsRows, setSubformsRows] = useState([]);
  const [includeSubforms, setIncludeSubforms] = useState([]);
  const [draggedRowIndex, setDraggedRowIndex] = useState();
  const [hoveredRowIndex, setHoveredRowIndex] = useState();
  const [discardModal, setDiscardModal] = useState(false);
  const [t] = useTranslation();
  let navigate = useNavigate();

  const getForm = async () => {

    await axiosInstance.get(`${process.env.REACT_APP_SERVER_URL}/api/forms/${id}`, { withCredentials: true })
    .then((response) => {
      console.log(response.data);
      setForms(response.data);
      setFormPublished(response.data.published);
      setSubformsRows(response.data.subforms);

      // initialize includeSubforms based on fetched data
      const initialIncludeSubforms = [];
      if (response.data.has_product_details) {
        initialIncludeSubforms.push('products');
      }
      if (response.data.has_manufacturers_site) {
        initialIncludeSubforms.push('manufacturers');
      }
      setIncludeSubforms(initialIncludeSubforms);

      setFormsCopy({
        forms: response.data,
        formPublished: response.data.published,
        subformsRows: response.data.subforms,
        includeSubforms: initialIncludeSubforms
      });
    })
    .catch((err) => console.log(err));
  };

  const getSubforms = async () => {
    try {
      const { data } = await fetchSubFormsDropdownValues();
      setSubforms(data);
    } catch (err) {
      console.error(err);
    }
  };



  useEffect(() => {
    getForm();
    getSubforms();
  }, []);

  const handleFormChange = (name, value) => {
    setForms({
      ...forms,
      [name]: value,
    });
  };

  const handleIncludeSubformsChange = (e) => {
    const selectedValues = e.target.value;
    setIncludeSubforms(selectedValues);

    // update form state with boolean values
    setForms({
      ...forms,
      has_product_details: selectedValues.includes('products'),
      has_manufacturers_site: selectedValues.includes('manufacturers'),
    });
  };


  // Save form values
  const handleFormSubmit = (event) => {
    // event.preventDefault();
    console.log(t("Saving form data"), ":", forms);

    if(forms.name === "")
    {
      toast.error(t("Form Name is required!"), { position: "top-center" });
      return;
    }

    const updatedForms = { ...forms };
    updatedForms.subforms = subformsRows.map(({id}, index) => ({id, order: index}));

    axiosInstance
      .put(`/api/forms/${id}`, updatedForms, { withCredentials: true })
      .then((resp) => {
        setResp(t("Form saved"));
        toast.success(t("Form Updated Successfully!"), { position: "top-center" });
        navigate(-1);
      })
      .catch((error) => {
        setResp(t("Error saving form"), ":", error);
      });
  };

  // Add Subforms dropdown

  useEffect(() => {
    const loadSubFormsDropdownValues = async () => {
      try {
        const { data } = await fetchSubFormsDropdownValues();
        setOptions(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error(t("Error loading stage dropdown values"), ":", error);
        setOptions([]);
      }
    };

    loadSubFormsDropdownValues();
  }, [t]);

  const handleDropdownChange = (index, event) => {
    const selectedId = event.target.value;
    const selectedOption = options.find(
      (option) => option.id === Number.parseInt(selectedId)
    );

    const newDropdowns = dropdowns.map((dropdown, i) =>
      i === index
        ? { ...dropdown, id: selectedId, textValue: selectedOption?.name || "" }
        : dropdown
    );
    setDropdowns(newDropdowns);
  };

  // Add a new empty dropdown
  const addDropdown = () => {
    setDropdowns([...dropdowns, { id: "", textValue: "" }]);
  };

  const tableRowProps = forms.disableEdit ? {} : {
    draggable: true,
    style: { cursor: 'grab' },
    onDragStart: (e) => {
      const row = e.target.closest('tr');
      const children = Array.from(e.target.closest('tbody').children);
      setDraggedRowIndex(children.indexOf(row));
      // console.log('draggedRowIndex', children.indexOf(row));
    },
    onDragOver: (e) => {
      e.preventDefault();
      const children = Array.from(e.target.closest('tbody').children);
      const hoveredRow = e.target.closest('tr');
      setHoveredRowIndex(children.indexOf(hoveredRow));
    },
    onDrop: () => {
      // console.log('hoveredRowIndex', hoveredRowIndex);
      const rowsCopy = [...subformsRows];
      const movedRow = subformsRows[draggedRowIndex];
      rowsCopy.splice(draggedRowIndex, 1);
      rowsCopy.splice(hoveredRowIndex, 0, movedRow);
      setSubformsRows(rowsCopy);
      setForms({...forms, "subforms": rowsCopy});
      setHoveredRowIndex(null);
      setDraggedRowIndex(null);
    },
  }

  const ActionCell = ({ row }) => {
    return (
      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <TableActions actions={[{text: 'Delete', color: "secondary", disabled:forms.disableEdit , style: {
          border: "solid 1px #D9D9D9",
        }, onClick: (row) => {
          const updatedSubForms = subformsRows.filter((subform) => subform.id !== row.id);
          setSubformsRows(updatedSubForms);
          setForms({ ...forms, subforms: updatedSubForms });
        }}]} row={row} />
      </div>
    );
  };

  return (
		<div
			className="content"
			style={{
				border: "solid 1px #E9E9E9",
				padding: "24px",
				borderRadius: "5px",
			}}
		>
			{resp && <p>{resp}</p>}
			<Grid item md={12}>
				<Formik
					initialValues={forms}
					enableReinitialize={true}
					onSubmit={handleFormSubmit}
				>
					<Form>
						<Field name="name">
							{({ field, meta }) => (
								<TextInput
									{...field}
									meta={meta}
									label={"Form name"}
									value={forms?.[`name`] || ""}
									placeholder={t("Form Name")}
									onChange={(value) => handleFormChange("name", value)}
									required
									// fullWidth={false}
								/>
							)}
						</Field>

						<Field name="description">
							{({ field, meta }) => (
								<TextInput
									{...field}
									meta={meta}
									label={"Form Description"}
									value={forms?.[`description`]}
									onChange={(value) => handleFormChange("description", value)}
									multiline={true}
									textareaWidth={"100%"}
								/>
							)}
						</Field>
						
						<Field name="subforms">
							{({ field, meta }) => (
								<AutocompleteInput
									{...field}
									meta={meta}
									label={"Sub forms"}
									options={subforms}
									onChange={(e, value) => {
										handleFormChange("subforms", e);
										setSubformsRows(e);
									}}
									// required={true}
									multiple={true}
									disabled={forms.disableEdit}
									value={forms?.subforms}
								/>
							)}
						</Field>

            <Field name="include_subforms">
              {({ field, meta }) => (
                <CheckboxGroup
                  {...field}
                  label="Include Products or Manufacturers Subforms:"
                  helperText="Select which additional subforms to include in this form"
                  value={includeSubforms}
                  onChange={handleIncludeSubformsChange}
                  disabled={forms.disableEdit}
                  style={{ marginTop: "2px", marginBottom: "2px" }}
                >
                  <Checkbox value="products" label="Products Details" />
                  <Checkbox value="manufacturers" label="Manufacturers Site" />
                </CheckboxGroup>
              )}
            </Field>

            <Typography variant="bodySmall" emphasis="low" gutterBottom style={{marginTop: "35px", textDecoration: 'underline'}}>{t("subforms_arrange")}</Typography>
						<Table
							columns={[
								{
									header: "Sub forms",
									accessor: "label",
								},
                {
                  accessor: 'action',
                  customCell: ActionCell,
                  align: 'right',
                },
							]}
							rows={subformsRows}
							hidePagination
							rowId="id"
							rowProps={tableRowProps}
						/>

            <Field name="published">
							{({ field, meta }) => (
								<SwitchInput
									{...field}
									meta={meta}
									label={t("Publish")}
									checked={forms.published === 1}
									value={forms?.published}
									disabled={forms.disableEdit}
									onChange={(checked) => {
										handleFormChange("published", checked);
									}}
                  style={{marginTop: '16px'}}
								/>
							)}
						</Field>

            <div style={{display: 'flex', justifyContent: 'flex-end', marginTop: '50px'}}>
            <Button
								color="primary"
          			onClick={() => setDiscardModal(true)}
								style={{
									padding: "12px 22px",
									width: "157px",
            						height: '40px',
            						marginRight: '24px',
								}}
          			text={t("Discard")}
						/>

						<Button
							color="primary"
							type="submit"
							style={{
								padding: "12px 22px",
								width: "157px",
                height: '40px',
							}}
              text={t("Save")}
						/>
            </div>

						{/* {error && <p>{error}</p>} */}
					</Form>
				</Formik>{" "}
			</Grid>
                  <Modal
                  open={discardModal}
                  message="Are you sure you want to discard your changes?"
                  buttonProps={[{onClick: () => {
                    setDiscardModal(false);
                    }},
                    { label: 'Confirm', onClick: () => {
                      setDiscardModal(false);
                      setForms(formsCopy.forms);
                      setSubformsRows(formsCopy.subformsRows);
                      setFormPublished(formsCopy.formPublished);
                      setIncludeSubforms(formsCopy.includeSubforms);
                    } }]}
                  hideHeader
                  id="hideHeader"
                />
		</div>
	);
}
